import { reducerWrapper } from '../support/utils';
import { LOADING_STATUS } from '../support/constants';
import { RESOLVE_CNAME } from '../actions/ResolveCnameActions';

var INIT_STATE = {
  loading: false,
  error: null,
  data: null,
  loadingStatus: LOADING_STATUS.INIT,
};

function Handler(state, action) {
  switch (action.type) {
    case RESOLVE_CNAME.response:
      return Object.assign(state, {
        loading: false,
        error: null,
        data: action.data,
        loadingStatus: LOADING_STATUS.LOADED,
      });
    default:
      return state;
  }
}

const ResolveCname = reducerWrapper(INIT_STATE, Handler, {
  request: [RESOLVE_CNAME],
  error: [RESOLVE_CNAME],
});

export default ResolveCname;
